module.exports = __webpack_public_path__ + "img/uid-success-bg.1c55032.png";